import { graphql } from '../../graphql';

export const getLandmarksQuery = graphql(`
  query Landmarks($cityId: ID!, $latitude: Float!, $longitude: Float!) {
    landmarks(cityId: $cityId, latitude: $latitude, longitude: $longitude) {
      id
      name
      locationGroupId
    }
  }
`);
